import { EditOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { Col, Row, Space } from 'antd';
import { DonationOutput, PermissionsEnum } from 'gql/types';
import { Button, DeletePopconfirm } from 'modules/common/components';
import { useCurrentUser } from 'modules/user/hooks/useCurrentUser';
import { FC } from 'react';
import { getTranslation } from 'utils/getTranslation';

import styles from './styles.module.scss';

import { useDonationCommentContext } from '../../contexts/DonationCommentActionsContext';

const t = getTranslation('donor.DonorDonationsTable');

type Props = {
  donation: DonationOutput;
  variant?: 'table' | 'card';
};

export const DonationCommentCell: FC<Props> = ({
  donation,
  variant = 'table',
}) => {
  const { addCommentHandler, deleteCommentHandler } =
    useDonationCommentContext();

  const currentUser = useCurrentUser();
  const canAddCommentsToDonation = currentUser.isCan(
    PermissionsEnum.AddCommentsToTheDonationAtTheDonorProfile
  );

  if (!donation.comment) {
    if (!canAddCommentsToDonation) return <>-</>;

    return variant === 'table' ? (
      <Button onClick={() => addCommentHandler(donation.id)}>
        {t('addComment')}
      </Button>
    ) : (
      <PlusSquareOutlined onClick={() => addCommentHandler(donation.id)} />
    );
  }

  return (
    <Row justify="space-between">
      <Col className={styles.comment}>
        <abbr title={donation.comment} className={styles.abbreviation}>
          {donation.comment}
        </abbr>
      </Col>

      {canAddCommentsToDonation && (
        <Space>
          <Col>
            <EditOutlined
              onClick={() =>
                addCommentHandler(donation.id, donation.comment ?? '')
              }
            />
          </Col>
          <Col>
            <DeletePopconfirm
              title={t('sureYouWantToDeleteThisComment')}
              onConfirm={() => deleteCommentHandler(donation.id)}
            />
          </Col>
        </Space>
      )}
    </Row>
  );
};
